import React, { useState, useEffect } from "react";

export default function RecHeader({ onFiltersOpen }) {
  const [dateDropdownOpen, setDateDropdownOpen] = useState(false);

  const handleFiltersOpen = () => {
    onFiltersOpen();
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (dateDropdownOpen) {
        setDateDropdownOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dateDropdownOpen]);

  return (
    <div className="w-full bg-white shadow-sm mb-6 border-b border-gray-200 font-ubuntu">
      <div className="container mx-auto py-3 px-4">
        <div className="flex items-center gap-x-3">
          {/* Duration dropdown */}
          <div className="relative">
            <div className="flex items-center text-gray-600 text-sm font-normal hover:text-gray-800 focus:outline-none">
              <span>Duration</span>
            </div>
            <div className="absolute hidden bg-white shadow-md rounded-md mt-2 w-48 py-1 z-10">
              {/* Dropdown content would go here */}
            </div>
          </div>

          {/* Date range section */}
          <div className="flex items-center relative">
            <button
              className="text-gray-400 text-sm font-medium flex items-center"
              onClick={(e) => {
                e.stopPropagation();
                setDateDropdownOpen(!dateDropdownOpen);
              }}
            >
              Start Date To End Date
              <svg
                className="w-4 h-4 ml-1"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>

            {dateDropdownOpen && (
              <div
                className="absolute left-0 top-full mt-1 w-44 bg-white shadow-lg z-10 border border-gray-200"
                style={{ boxShadow: "0 2px 10px rgba(0,0,0,0.1)" }}
              >
                <div className="py-1">
                  <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                    Today
                  </button>
                  <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                    Last 30 Days
                  </button>
                  <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                    This Month
                  </button>
                  <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                    Last Month
                  </button>
                  <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                    Last 90 Days
                  </button>
                  <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                    Last 6 Months
                  </button>
                  <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                    Last 1 Year
                  </button>
                  <button className="w-full text-left px-4 py-2 text-sm text-gray-700 bg-gray-200">
                    Custom Range
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* Vertical divider - taller to override padding */}
          <div className="h-8 w-px bg-gray-300 my-auto ml-5"></div>

          {/* Recruiter section with dropdown */}
          <div className="flex items-center">
            <span className="text-gray-600 text-sm font-medium mr-2">
              Status
            </span>
            <div className="inline-block relative">
              <div className="flex items-center bg-white border border-gray-300 rounded py-1 px-2 text-sm">
                <select className="w-full border-none text-gray-900 appearance-none bg-white focus:outline-none">
                  <option>All</option>
                  <option>Open</option>
                </select>
                <svg
                  className="w-4 h-4 ml-1"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
            </div>
          </div>

          {/* Recruiter section with dropdown */}
          <div className="flex items-center">
            <span className="text-gray-600 text-sm font-medium mr-2">
              Job
            </span>
            <div className="inline-block relative">
              <div className="flex items-center bg-white border border-gray-300 rounded py-1 px-2 text-sm">
                <select className="w-full border-none text-gray-900 appearance-none bg-white focus:outline-none">
                  <option> All </option>
                  <option></option>
                </select>
                <svg
                  className="w-4 h-4 ml-1"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
            </div>
          </div>

          {/* Vertical divider - taller to override padding */}
          <div className="h-8 w-px bg-gray-300 my-auto"></div>

          {/* Search input */}
          <div className="relative">
            <div className="flex items-center border border-gray-300 rounded bg-gray-200">
              <div className="pl-2 pr-2">
                <svg
                  className="w-4 h-4 text-gray-500"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <input
                type="text"
                placeholder="Start typing to search"
                className="py-1 px-2 text-sm w-72 border-none rounded-none text-black focus:outline-none"
              />
            </div>
          </div>

          {/* Filters button */}
          <div className="ml-auto">
            <button
              className="flex items-center text-gray-600 hover:text-gray-800"
              onClick={handleFiltersOpen}
            >
              <svg
                className="w-4 h-4 mr-1"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fillRule="evenodd"
                  d="M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z"
                  clipRule="evenodd"
                />
              </svg>
              <span className="text-sm font-medium">Filters</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
